import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { getAreaFromCoords } from "../../../GlobalUtilities/geolocation"; // Adjust the import path as necessary

//import { Marker } from "@react-google-maps/api";
//import { GoogleMap, LoadScript } from "@react-google-maps/api";
import DynamicMap from "../../../GlobalUtilities/DynamicMap";

// const containerStyle = {
//   width: '100%',
//   height: '400px'
// };

// const center = {
//   lat: 26.7875728,  // Example: New Delhi latitude
//   lng: 83.3765671   // Example: New Delhi longitude
// };
import { API_BASE_URL } from "../../../GlobalUtilities/constants/Constants";


const MediaGallery = () => {
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [openViewer, setOpenViewer] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [geoLocation, setGeoLocation] = useState({ lat: "Unavailable", lon: "Unavailable", area: "Unknown" });

  const mediaBaseUrl = `${API_BASE_URL}/upload/uploads/`;

  const fetchFiles = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/upload/fetch_images.php`);
      const data = await res.json();

      if (data.status === "success" && Array.isArray(data.data)) {
        const imageFiles = data.data.filter(item => item.type === "image");
        const videoFiles = data.data.filter(item => item.type === "video");

        setImages(imageFiles);
        setVideos(videoFiles);
      }
    } catch (err) {
      console.error("Error fetching files:", err);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleOpenViewer = (media) => {
    if (media.type === "video") {
      const baseName = media.filename.replace('_front.mov', '').replace('_back.mov', '');
      const frontVideo = videos.find(v => v.filename.startsWith(baseName) && v.filename.includes('_front'));
      const backVideo = videos.find(v => v.filename.startsWith(baseName) && v.filename.includes('_back'));

      if (frontVideo && backVideo) {
        setSelectedMedia({ front: frontVideo, back: backVideo, baseName });
      } else {
        setSelectedMedia(media);
      }
    } else {
      setSelectedMedia(media);
    }
    setOpenViewer(true);
  };

  const handleCloseViewer = () => {
    setOpenViewer(false);
    setSelectedMedia(null);
  };

  const renderMediaCard = (media, type, index) => {
    const url = mediaBaseUrl + media.filename;
    return (
      <Grid item key={index} xs={6} sm={4} md={2.4}>
        <Card
          sx={{
            width: 100,
            height: 120,
            overflow: "hidden",
            cursor: "pointer"
          }}
          onClick={() => handleOpenViewer(media)}
        >
          {type === "image" ? (
            <CardMedia
              component="img"
              image={url}
              alt={media.filename}
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            <CardMedia
              component="video"
              src={url}
              controls={false}
              muted
              sx={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}
          <CardContent sx={{ padding: "4px" }}>
            <Typography variant="caption" sx={{ fontSize: "10px" }} noWrap>
              {media.filename}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  useEffect(() => {
    const fetchGeoLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          const { latitude, longitude } = position.coords;
          const area = await getAreaFromCoords(latitude, longitude);
          setGeoLocation({ lat: latitude, lon: longitude, area });
        }, (error) => {
          console.error("Geolocation error:", error.message);
          setGeoLocation({ lat: "Unavailable", lon: "Unavailable", area: "Unknown" });
        });
      } else {
        console.error("Geolocation is not supported by this browser.");
        setGeoLocation({ lat: "Unavailable", lon: "Unavailable", area: "Unknown" });
      }
    };

    fetchGeoLocation();
  }, []);

  useEffect(() => {
    const fetchSelectedMediaArea = async () => {
      if (selectedMedia && selectedMedia.lat && selectedMedia.lon) {
        const area = await getAreaFromCoords(selectedMedia.lat, selectedMedia.lon);
        setGeoLocation(prev => ({ ...prev, area }));
      }
    };

    fetchSelectedMediaArea();
  }, [selectedMedia]);

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h6" gutterBottom>📷 Uploaded Images</Typography>
      <Grid container spacing={2}>
        {images.map((img, i) => renderMediaCard(img, "image", i))}
      </Grid>

      <Typography variant="h6" gutterBottom style={{ marginTop: 30 }}>🎥 Uploaded Videos</Typography>
      <Grid container spacing={2}>
        {videos.map((vid, i) => renderMediaCard(vid, "video", i))}
      </Grid>

      <Dialog open={openViewer} onClose={handleCloseViewer} maxWidth="md" fullWidth scroll="paper">
        <DialogContent sx={{ position: "relative", p: 2, overflow: "auto" }}>
          <IconButton
            aria-label="close"
            onClick={handleCloseViewer}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              backgroundColor: 'rgba(0,0,0,0.6)',
              color: '#fff',
              zIndex: 2,
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.8)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>

          {selectedMedia && (
            <div style={{ width: "100%", textAlign: "center" }}>
              {selectedMedia.front && selectedMedia.back ? (
                <>
                  <Typography variant="h6" sx={{ mb: 2 }}>Front Camera</Typography>
                  <video
                    src={mediaBaseUrl + selectedMedia.front.filename}
                    controls
                    style={{
                      width: "100%",
                      maxHeight: "40vh",
                      objectFit: "contain",
                      borderRadius: 8,
                      marginBottom: "16px"
                    }}
                  />
                  <Typography variant="h6" sx={{ mb: 2 }}>Back Camera</Typography>
                  <video
                    src={mediaBaseUrl + selectedMedia.back.filename}
                    controls
                    style={{
                      width: "100%",
                      maxHeight: "40vh",
                      objectFit: "contain",
                      borderRadius: 8
                    }}
                  />
                </>
              ) : (
                <>
                  {selectedMedia.type === "image" && (
                    <img
                      src={mediaBaseUrl + selectedMedia.filename}
                      alt={selectedMedia.filename}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "80vh",
                        objectFit: "contain",
                        borderRadius: 8
                      }}
                    />
                  )}
                  {selectedMedia.type === "video" && (
                    <video
                      src={mediaBaseUrl + selectedMedia.filename}
                      controls
                      style={{
                        maxWidth: "100%",
                        maxHeight: "80vh",
                        objectFit: "contain",
                        borderRadius: 8
                      }}
                    />
                  )}
                </>
              )}

              <Box
                sx={{
                  width: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  color: "#fff",
                  borderRadius: "8px",
                  padding: "16px",
                  boxSizing: "border-box",
                  overflowWrap: "break-word",
                  textAlign: "center",
                  marginTop: "16px"
                }}
              >
                {selectedMedia?.front && selectedMedia?.back ? (
                  <>
                    <Typography variant="h6" sx={{ mb: 2 }}>Front Camera Details</Typography>
                    <Typography variant="body2">Filename: {selectedMedia.front.filename}</Typography>
                    <Typography variant="body2">Uploaded by: {selectedMedia.front.username}</Typography>
                    <Typography variant="body2">Timestamp: {dayjs(selectedMedia.front.systemtime).format("MMMM D, YYYY h:mm A")}</Typography>
                    <Typography variant="body2">IP: {selectedMedia.front.ip}</Typography>
                    <Typography variant="body2">Latitude and Longitude: {selectedMedia.front.lat}, {selectedMedia.front.lon}</Typography>
                    <Typography variant="body2">Area: {geoLocation.area}</Typography>
                    <Box sx={{ height: "20px" }} />

                    <Typography variant="h6" sx={{ mb: 2 }}>Back Camera Details</Typography>
                    <Typography variant="body2">Filename: {selectedMedia.back.filename}</Typography>
                    <Typography variant="body2">Uploaded by: {selectedMedia.back.username}</Typography>
                    <Typography variant="body2">Timestamp: {dayjs(selectedMedia.back.systemtime).format("MMMM D, YYYY h:mm A")}</Typography>
                    <Typography variant="body2">IP: {selectedMedia.back.ip}</Typography>
                    <Typography variant="body2">Latitude and Longitude: {selectedMedia.back.lat}, {selectedMedia.back.lon}</Typography>
                    <Typography variant="body2">Area: {geoLocation.area}</Typography>



                    <div>
                      <DynamicMap
                        lat={selectedMedia.back.lat}
                        lon={selectedMedia.back.lon}
                      />
                    </div>



                  </>
                ) : (
                  <>
                    <Typography variant="h6" sx={{ mb: 2 }}>Image Details</Typography>
                    <Typography variant="body2">Filename: {selectedMedia.filename}</Typography>
                    <Typography variant="body2">Uploaded by: {selectedMedia.username}</Typography>
                    <Typography variant="body2">Timestamp: {dayjs(selectedMedia.systemtime).format("MMMM D, YYYY h:mm A")}</Typography>
                    <Typography variant="body2">IP: {selectedMedia.ip}</Typography>
                    <Typography variant="body2">Latitude and Longitude: {selectedMedia.lat}, {selectedMedia.lon}</Typography>
                    <Typography variant="body2">Area: {geoLocation.area}</Typography>
                    <div>
                      <DynamicMap
                        lat={selectedMedia.lat}
                        lon={selectedMedia.lon}
                      />
                    </div>
                  </>
                )}
              </Box>
            </div>


          )}
        </DialogContent>
      </Dialog>




    </div>
  );
};

export default MediaGallery;
